import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import Avatar from 'flarum/common/components/Avatar';
import Button from 'flarum/common/components/Button';
import username from 'flarum/common/helpers/username';
import { claim, release } from '../blocks';
import { t, ts } from '../util';
export function profileEnabled() {
  return app.forum.attribute('concourseShowProfile') !== false;
}
/**
 * The reader's own card: cover, avatar, name, handle, bio and Edit Profile.
 * A guest gets the forum's welcome and the sign-up and log-in buttons
 * instead.
 *
 * Everything comes from the session user already in the payload: no request.
 * The cover is the member's own from ernestdefoe/backdrop (framed exactly as
 * on their profile) or sycho/flarum-profile-cover, otherwise a band in their
 * own colour; the bio is fof/user-bio's.
 */
export default class ProfileCard extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    claim('profile', this.attrs.host);
  }
  onremove() {
    release('profile', this.attrs.host);
  }
  view() {
    const user = app.session.user;
    return user ? this.member(user) : this.guest();
  }
  member(user) {
    const bioHtml = user.attribute('bioHtml');
    const bio = user.attribute('bio');
    const color = user.color() || 'var(--cc-faint)';
    return m("section", {
      className: "ConcourseBlock ConcourseProfile",
      "aria-label": ts('profile.label')
    }, cover(user, color), m("div", {
      className: "ConcourseProfile-body"
    }, m(Link, {
      href: app.route.user(user),
      className: "ConcourseProfile-avatar"
    }, m(Avatar, {
      user: user
    })), m(Link, {
      href: app.route.user(user),
      className: "ConcourseProfile-name"
    }, username(user)), m("span", {
      className: "ConcourseProfile-handle"
    }, "@", user.username()), bioHtml ? m("div", {
      className: "ConcourseProfile-bio"
    }, m.trust(bioHtml)) : bio ? m("p", {
      className: "ConcourseProfile-bio"
    }, bio) : null, m(Link, {
      href: app.route.user(user),
      className: "Button ConcourseProfile-edit"
    }, t('profile.edit'))));
  }
  guest() {
    const forum = app.forum;
    const description = forum.attribute('description');
    return m("section", {
      className: "ConcourseBlock ConcourseProfile ConcourseProfile--guest",
      "aria-label": ts('profile.label')
    }, m("div", {
      className: "ConcourseProfile-body"
    }, m("h2", {
      className: "ConcourseProfile-name"
    }, t('profile.welcome', {
      forum: forum.attribute('title')
    })), description ? m("p", {
      className: "ConcourseProfile-bio"
    }, description) : null, forum.attribute('allowSignUp') ? m(Button, {
      className: "Button Button--primary ConcourseProfile-edit",
      onclick: () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/SignUpModal'))
    }, app.translator.trans('core.forum.header.sign_up_link')) : null, m(Button, {
      className: "Button ConcourseProfile-edit",
      onclick: () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'))
    }, app.translator.trans('core.forum.header.log_in_link'))));
  }
}
const clamp = (value, min, max, fallback) => {
  const n = Number(value);
  return Number.isFinite(n) ? Math.min(max, Math.max(min, n)) : fallback;
};

/**
 * The card's cover.
 *
 * Backdrop sends `{url, small, x, y, zoom}`: the small copy (960 px) is plenty
 * for a 19rem card, and x/y/zoom are the focal point and zoom the member set
 * in Backdrop's editor, so the card shows the same part of the picture as
 * their profile. Zoomed out below 1×, a blurred copy fills the edges, as
 * Backdrop does.
 */
function cover(user, color) {
  const backdrop = user.attribute('backdrop');
  const src = backdrop && (backdrop.small || backdrop.url);
  if (src) {
    const x = clamp(backdrop.x, 0, 100, 50);
    const y = clamp(backdrop.y, 0, 100, 50);
    const zoom = clamp(backdrop.zoom, 0.5, 4, 1);
    return m("div", {
      className: 'ConcourseProfile-cover ConcourseProfile-cover--backdrop' + (zoom < 1 ? ' ConcourseProfile-cover--out' : ''),
      style: {
        // Only ever inside url("…"), with the characters that could end it encoded.
        '--cc-cover-image': `url("${String(src).replace(/["\\\n\r]/g, c => encodeURIComponent(c))}")`,
        '--cc-cover-x': `${x}%`,
        '--cc-cover-y': `${y}%`,
        '--cc-cover-zoom': String(zoom)
      },
      "aria-hidden": "true"
    });
  }
  const image = user.attribute('cover');
  return m("div", {
    className: 'ConcourseProfile-cover' + (image ? ' ConcourseProfile-cover--image' : ''),
    style: {
      '--cover-color': color
    }
  }, image ? m("img", {
    src: image,
    alt: "",
    loading: "lazy"
  }) : null);
}
flarum.reg.add('ernestdefoe-concourse', 'forum/components/ProfileCard', ProfileCard);